import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {DumpsterFire} from "../../DumpsterFire";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {TimelineLite, gsap} from "gsap";

export class DFFSOutroRunner implements SimplePresentation {

    public shouldRun(): boolean {
        return (DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1) && (DumpsterFire.model.data.nextMode === DumpsterFireGameMode.EXTRA_SPIN || DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL) && !DumpsterFire.model.gameData.brokeTheBank && DumpsterFire.model.isFreespin && DumpsterFire.model.data.extraSpinCount === 0;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
            delay: 0.4
        })
        tl.add(() => {
            controller.setSkipCallback(() => {
                DumpsterFire.soundPlayer.stopOutroCountUp();
                tl.seek("POST_COUNTUP", false)
                controller.setSkipCallback();
            });
        });
        DumpsterFire.keypadPlugin.setZeroBetSpinCounter(-1);
        tl.add(DumpsterFire.fsOutro.showOutro(), 0);
        tl.addLabel("POST_COUNTUP");
        tl.add(() => {
            controller.setSkipCallback();
        });
        tl.add(DumpsterFire.fsOutro.enableButton(() => this.onButtonClickController(controller)));
    }

    private onButtonClickController(controller: SimplePresentationRunnerController) {
        DumpsterFire.keypadPlugin.show();
        controller.setSkipCallback();
        controller.finish();
    }
}